import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TooltipBaseComponent } from '../tooltip-base/tooltip-base.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-hover-tooltip',
    imports: [MatTooltipModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './hover-tooltip.component.html',
})
export class HoverTooltipComponent implements TooltipBaseComponent {
    @Input() message: string = '';

    /**
     * If true, the tooltip will be an informational icon, if false, it will be a question mark icon
     */
    @Input() moreInfo: boolean = false;
}
